/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lg_Guest_TitleInputs */

const en_lg_guest_title = /** @type {(inputs: Lg_Guest_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guests enter with approval`)
};

const id_lg_guest_title = /** @type {(inputs: Lg_Guest_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tamu masuk setelah disetujui`)
};

/**
* | output |
* | --- |
* | "Guests enter with approval" |
*
* @param {Lg_Guest_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const lg_guest_title = /** @type {((inputs?: Lg_Guest_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lg_Guest_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_lg_guest_title(inputs)
	return en_lg_guest_title(inputs)
});